import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_PIE = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_PIE' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <span className='eleHeader'>DSM-V Diagnosis:</span> 
                    <textarea id='txtDsmDiagnosis' name='txtDsmDiagnosis' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Purpose of Contact:</span>
                    <span className='small'>(1) Address Undesirable Behaviors  </span>
                    <textarea id='txtPurposeContact' name='txtPurposeContact' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Intervention/Activity :</span> 
                    <span className='small'>(What you did)  </span>
                    <textarea id='txtInterventionActivity' name='txtInterventionActivity' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Effectiveness of Intervention/Activity :</span> 
                    <textarea id='txtEffectivenessIntervention' name='txtEffectivenessIntervention' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Progress:</span>
                    <span className='small'> </span>
                    <textarea id='txt' name='' className='add-only'></textarea>
                </p> 


            </div>
        </form>

    )
} 